import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { LOGO_URL } from "@/constants";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate(user.role === "trader" ? "/trade/dashboard" : "/admin", { replace: true });
    return null;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-kera-cream kera-grain flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Link to="/">
            <img src={LOGO_URL} alt="KERA" className="h-12 w-auto mx-auto" data-testid="admin-login-logo" />
          </Link>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-kera-copper">
            Brand Studio — Admin
          </p>
        </div>
        <form
          onSubmit={onSubmit}
          className="bg-kera-card border border-kera-line rounded-2xl p-8 shadow-sm"
          data-testid="admin-login-form"
        >
          <label className="block font-mono text-[10px] uppercase tracking-[0.2em] text-kera-muted mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-login-email"
            className="w-full rounded-lg border border-kera-line bg-kera-cream px-4 py-2.5 text-sm text-kera-ink outline-none focus:border-kera-gold mb-5"
          />
          <label className="block font-mono text-[10px] uppercase tracking-[0.2em] text-kera-muted mb-2">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-login-password"
            className="w-full rounded-lg border border-kera-line bg-kera-cream px-4 py-2.5 text-sm text-kera-ink outline-none focus:border-kera-gold"
          />
          {error && (
            <p className="mt-4 text-sm text-red-700" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-6 w-full rounded-full bg-kera-ink text-kera-cream py-3 text-sm font-medium tracking-wide hover:bg-kera-copper transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-center mt-6">
          <Link to="/" className="font-mono text-[10px] uppercase tracking-[0.2em] text-kera-muted hover:text-kera-copper transition-colors" data-testid="admin-login-back">
            ← Back to site
          </Link>
        </p>
      </div>
    </div>
  );
}
